<style>
  /* bic-select zeigt bei onlyShowPlaceholder den Text standardmäßig grau (Placeholder-Optik) an.
     Wenn "Alle erlaubt" den tatsächlichen Auswahlwert darstellt, soll er wie ein normaler Wert wirken. */
  .force-value-color ::ng-deep input.text-gray-500 {
    color: #111827 !important;
  }
</style>
<div class="bg-white flex flex-col gap-4 p-4 border border-gray-200 rounded-lg">
  <!-- AUSWAHLMODUS -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Auswahlmodus</span>
    <div class="border-b border-gray-200"></div>
  </div>
  <label class="text-sm font-medium text-gray-900 leading-normal">Wie sollen Prüfregeln zugeordnet werden?*</label>
  <div class="grid grid-cols-2 gap-4 -mt-2">
    <button
      (click)="selectMode('manual')"
      [class]="state.fileSelectionMode === 'manual' ? 'border-gray-500 bg-gray-100' : 'border-gray-200 bg-white hover:border-gray-300'"
      class="flex items-center gap-4 px-4 py-2 rounded-lg border transition-colors text-left">
      <div class="flex items-center justify-center w-6 h-6 shrink-0">
        <fa-icon
          [icon]="faHandPointer"
          [class]="state.fileSelectionMode === 'manual' ? 'text-gray-500' : 'text-gray-300'"
          class="text-base"></fa-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-medium text-gray-900 leading-normal">Manuell</span>
        <span class="text-xs font-normal text-gray-900 leading-normal">Nutzer wählt Dateien beim Start, innerhalb des hier festgelegten Rahmens.</span>
      </div>
    </button>
    <button
      (click)="selectMode('predefined')"
      [class]="state.fileSelectionMode === 'predefined' ? 'border-gray-500 bg-gray-100' : 'border-gray-200 bg-white hover:border-gray-300'"
      class="flex items-center gap-4 px-4 py-2 rounded-lg border transition-colors text-left">
      <div class="flex items-center justify-center w-6 h-6 shrink-0">
        <fa-icon
          [icon]="faThumbtackAngle"
          [class]="state.fileSelectionMode === 'predefined' ? 'text-gray-500' : 'text-gray-300'"
          class="text-base"></fa-icon>
      </div>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-medium text-gray-900 leading-normal">Vordefiniert</span>
        <span class="text-xs font-normal text-gray-900 leading-normal">Filter wählt Dateien automatisch aus dem Projekt</span>
      </div>
    </button>
  </div>

  <!-- Dateiauswahl konfigurieren -->
  @if (state.fileSelectionMode === 'predefined') {
    <div class="flex flex-col gap-1 pt-2 pb-1">
      <span class="text-[11px] font-medium text-gray-400 uppercase">Verhalten bei mehreren Treffern</span>
      <div class="border-b border-gray-200"></div>
    </div>
    <div class="flex flex-col gap-4">
      <div class="grid grid-cols-2 gap-4">
        <button
          (click)="selectPredefinedScope('all')"
          [class]="state.predefinedFileSelectionScope === 'all' ? 'border-gray-500 bg-gray-100' : 'border-gray-200 bg-white hover:border-gray-300'"
          class="flex items-center gap-4 px-4 py-2 rounded-lg border transition-colors text-left">
          <div class="flex items-center justify-center w-6 h-6 shrink-0">
            <fa-icon
              [icon]="faLayerGroup"
              [class]="state.predefinedFileSelectionScope === 'all' ? 'text-gray-500' : 'text-gray-300'"
              class="text-base"></fa-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-medium text-gray-900 leading-normal">Alle Dateien prüfen</span>
            <span class="text-xs font-normal text-gray-900 leading-normal">Jede hochgeladene Datei wird automatisch geprüft</span>
          </div>
        </button>
        <button
          (click)="selectPredefinedScope('selected')"
          [class]="state.predefinedFileSelectionScope === 'selected' ? 'border-gray-500 bg-gray-100' : 'border-gray-200 bg-white hover:border-gray-300'"
          class="flex items-center gap-4 px-4 py-2 rounded-lg border transition-colors text-left">
          <div class="flex items-center justify-center w-6 h-6 shrink-0">
            <fa-icon
              [icon]="faGear"
              [class]="state.predefinedFileSelectionScope === 'selected' ? 'text-gray-500' : 'text-gray-300'"
              class="text-base"></fa-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-medium text-gray-900 leading-normal">Ausgewählte Dateien prüfen</span>
            <span class="text-xs font-normal text-gray-900 leading-normal">Nutzer*in wählt zur Ausführung aus den Treffern</span>
          </div>
        </button>
      </div>

      @if (state.predefinedFileSelectionScope === 'selected') {
        <!-- ERLAUBTE DATEIEN -->
        <div class="flex flex-col gap-1 pt-2 pb-1">
          <span class="text-[11px] font-medium text-gray-400 uppercase">Erlaubte Dateien</span>
          <div class="border-b border-gray-200"></div>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="flex min-w-0 flex-col gap-2">
            <!-- Dateitypen (predefined/selected) -->
            @if (fileSelectionDataLoaded) {
              <bic-select
                (valueChange)="updateFileTypes($event)"
                [class.force-value-color]="areAllFileTypesSelected()"
                [label]="'Dateitypen'"
                [multiple]="true"
                [onlyShowPlaceholder]="areAllFileTypesSelected()"
                [placeholder]="areAllFileTypesSelected() ? 'Alle erlaubt' : 'Dateitypen auswählen'"
                [value]="getFileTypesSelectionValue()">
                <bic-dropdown-element
                  #fileTypesSelectAllOption
                  (onClick)="toggleAllFileTypes()"
                  [selection]="true">{{ getFileTypesSelectAllLabel() }}</bic-dropdown-element>
                @for (type of availableFileTypes; track type) {
                  <bic-dropdown-element [selection]="true" [value]="type">{{ fileTypeLabels[type] ?? type }}</bic-dropdown-element>
                }
              </bic-select>
            } @else {
              <bic-select
                [disabled]="true"
                [label]="'Dateitypen'"
                [multiple]="true"
                [placeholder]="'Wird geladen...'"
                [value]="[]">
              </bic-select>
            }
            @if (showErrors && state.fileTypes.length === 0) {
              <span class="text-xs text-red-600">Mindestens ein Dateityp muss gewählt sein.</span>
            }
          </div>

          <div class="flex min-w-0 flex-col gap-2">
            <!-- Dokumentenklassen -->
            @if (fileSelectionDataLoaded) {
              <bic-select
                (valueChange)="updateDocumentClasses($event)"
                [class.force-value-color]="areAllDocumentClassesSelected()"
                [label]="'Dokumentenklassen'"
                [multiple]="true"
                [onlyShowPlaceholder]="areAllDocumentClassesSelected()"
                [placeholder]="areAllDocumentClassesSelected() ? 'Alle erlaubt' : 'Dokumentenklassen auswählen'"
                [value]="getDocumentClassesSelectionValue()">
                <bic-dropdown-element
                  #documentClassesSelectAllOption
                  (onClick)="toggleAllDocumentClasses()"
                  [selection]="true">{{ getDocumentClassesSelectAllLabel() }}</bic-dropdown-element>
                @for (cls of getFilteredDocumentClasses(); track cls.id) {
                  <bic-dropdown-element [selection]="true" [value]="cls.id!">{{ cls.name }}</bic-dropdown-element>
                }
              </bic-select>
            } @else {
              <bic-select
                [disabled]="true"
                [label]="'Dokumentenklassen'"
                [multiple]="true"
                [placeholder]="'Wird geladen...'"
                [value]="[]">
              </bic-select>
            }
          </div>
        </div>

        <!-- Hinweis zu erlaubten Dateien -->
        <div class="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg">
          <fa-icon [icon]="faCircleInfo" class="text-gray-500 text-xs shrink-0"></fa-icon>
          <span class="text-sm font-medium text-gray-500">Beispiel: PDF + Raumbuch erlaubt bzw. zeigt nur PDFs, die als Raumbuch klassifiziert sind.</span>
        </div>

        <!-- FILTER -->
        <div class="flex flex-col gap-1 pt-2 pb-1">
          <span class="text-[11px] font-medium text-gray-400 uppercase">Filter</span>
          <div class="border-b border-gray-200"></div>
        </div>

        <div class="flex flex-col gap-2.5 rounded-lg bg-gray-100 px-6 py-4">
          <div class="flex flex-col gap-6 main-sm:flex-row main-sm:gap-[26px]">
            <!-- Uploadzeitraum -->
            <div class="flex flex-1 flex-col gap-1 min-w-0">
              <bic-select (valueChange)="updateUploadPeriod($event)"
                          [label]="'Uploadzeitraum'"
                          [placeholder]="'Uploadzeitraum auswählen'"
                          [value]="state.predefinedUploadPeriod">
                @for (period of uploadPeriodOptions; track period.value) {
                  <bic-dropdown-element [value]="period.value">{{ period.label }}</bic-dropdown-element>
                }
              </bic-select>
              <span class="text-xs font-normal text-gray-500 leading-[1.5]">Nur Dateien aus diesem Zeitraum werden berücksichtigt</span>
            </div>

            <!-- Ersteller*in. Projektnutzer gibt es im Admin-Modus (projektlos) nicht; das Feld
                 bliebe leer, deshalb ausgeblendet. Ohne Einschränkung = alle. -->
            @if (projectId) {
              <div class="flex flex-1 flex-col gap-1 min-w-0">
                <bic-select (valueChange)="updateCreators($event)"
                            [label]="'Ersteller*in'"
                            [multiple]="true"
                            [placeholder]="'Alle Projektmitglieder (Standard)'"
                            [value]="state.predefinedCreatorIds">
                  @for (creator of projectCreators; track creator.id) {
                    <bic-dropdown-element [selection]="true" [value]="creator.id">{{ getCreatorLabel(creator) }}
                    </bic-dropdown-element>
                  }
                </bic-select>
              </div>
            }
          </div>

          <!-- Dateiname-Pattern -->
          <div class="flex flex-col gap-1">
            <bic-input (valueChange)="updateFileNameRegex($event)"
                       [label]="'Dateiname-Pattern'"
                       [placeholder]="'*_final.*'"
                       [value]="state.predefinedFileNameRegex">
            </bic-input>
            <span class="text-xs font-normal text-gray-500 leading-[1.5]">Glob-Pattern oder Regex; leer = alle Dateinamen</span>
          </div>
        </div>
      }
    </div>
  }

  <!-- Ausführungsparameter (nur manuell) -->
  @if (state.fileSelectionMode === 'manual') {
    <!-- ERLAUBTE DATEIEN -->
    <div class="flex flex-col gap-1 pt-2 pb-1">
      <span class="text-[11px] font-medium text-gray-400 uppercase">Erlaubte Dateien</span>
      <div class="border-b border-gray-200"></div>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <div class="flex min-w-0 flex-col gap-2">
        <!-- Dateitypen (manual) -->
        @if (fileSelectionDataLoaded) {
          <bic-select
            (valueChange)="updateFileTypes($event)"
            [class.force-value-color]="areAllFileTypesSelected()"
            [label]="'Dateitypen'"
            [multiple]="true"
            [onlyShowPlaceholder]="areAllFileTypesSelected()"
            [placeholder]="areAllFileTypesSelected() ? 'Alle erlaubt' : 'Dateitypen auswählen'"
            [value]="getFileTypesSelectionValue()">
            <bic-dropdown-element
              #fileTypesSelectAllOption
              (onClick)="toggleAllFileTypes()"
              [selection]="true">{{ getFileTypesSelectAllLabel() }}</bic-dropdown-element>
            @for (type of availableFileTypes; track type) {
              <bic-dropdown-element [selection]="true" [value]="type">{{ fileTypeLabels[type] ?? type }}</bic-dropdown-element>
            }
          </bic-select>
        } @else {
          <bic-select
            [disabled]="true"
            [label]="'Dateitypen'"
            [multiple]="true"
            [placeholder]="'Wird geladen...'"
            [value]="[]">
          </bic-select>
        }
        @if (showErrors && state.fileTypes.length === 0) {
          <span class="text-xs text-red-600">Mindestens ein Dateityp muss gewählt sein.</span>
        }
      </div>

      <div class="flex min-w-0 flex-col gap-2">
        <!-- Dokumentenklassen -->
        @if (fileSelectionDataLoaded) {
          <bic-select
            (valueChange)="updateDocumentClasses($event)"
            [class.force-value-color]="areAllDocumentClassesSelected()"
            [label]="'Dokumentenklassen'"
            [multiple]="true"
            [onlyShowPlaceholder]="areAllDocumentClassesSelected()"
            [placeholder]="areAllDocumentClassesSelected() ? 'Alle erlaubt' : 'Dokumentenklassen auswählen'"
            [value]="getDocumentClassesSelectionValue()">
            <bic-dropdown-element
              #documentClassesSelectAllOption
              (onClick)="toggleAllDocumentClasses()"
              [selection]="true">{{ getDocumentClassesSelectAllLabel() }}</bic-dropdown-element>
            @for (cls of getFilteredDocumentClasses(); track cls.id) {
              <bic-dropdown-element [selection]="true" [value]="cls.id!">{{ cls.name }}</bic-dropdown-element>
            }
          </bic-select>
        } @else {
          <bic-select
            [disabled]="true"
            [label]="'Dokumentenklassen'"
            [multiple]="true"
            [placeholder]="'Wird geladen...'"
            [value]="[]">
          </bic-select>
        }
      </div>
    </div>

    <!-- Hinweis zu erlaubten Dateien -->
    <div class="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg">
      <fa-icon [icon]="faCircleInfo" class="text-gray-500 text-xs shrink-0"></fa-icon>
      <span class="text-sm font-medium text-gray-500">Beispiel: PDF + Raumbuch erlaubt bzw. zeigt nur PDFs, die als Raumbuch klassifiziert sind.</span>
    </div>

    <div class="flex flex-col gap-1 pt-2 pb-1">
      <span class="text-[11px] font-medium text-gray-400 uppercase">Ausführungsparameter</span>
      <div class="border-b border-gray-200"></div>
    </div>

    <!-- Anzahl Dateien + Hinweistext -->
    <div class="flex flex-col gap-4 px-6 py-4 rounded-lg bg-gray-50">
      <div class="flex flex-row gap-[26px]">
        <div class="flex flex-col gap-1 flex-1">
          <bic-input (valueChange)="updateMinFiles($event)"
                     [label]="'Anzahl Dateien'"
                     [min]="1"
                     [placeholder]="'Min 1'"
                     [value]="state.minFiles!.toString()">
          </bic-input>
          <span class="text-xs font-normal text-gray-500 leading-[1.5]">Bei Max = 1 verhält sich der Check als Single-File-Auswahl</span>
        </div>
        <div class="flex flex-col flex-1">
          <bic-input (valueChange)="updateMaxFiles($event)"
                     [min]="1"
                     [placeholder]="'Max leer = unbegrenzt'"
                     [value]="state.maxFiles?.toString() ?? ''"
                     [label]="'&nbsp;'"
                     >
          </bic-input>
        </div>
      </div>

      <bic-input (valueChange)="updateUserHint($event)"
                 [label]="'Hinweistext für den Nutzer'"
                 [placeholder]="'Bitte aktuelle Raumbücher hochladen, die das gesamte Erdgeschoss abdecken.'"
                 [value]="state.userHint">
      </bic-input>
      <span class="-mt-3 text-xs font-normal text-gray-500 leading-[1.5]">Wird dem Nutzer in der Dateiauswahl bei der Ausführung angezeigt</span>
    </div>
  }
</div>
